import { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { PaginationState, SortingState } from "@tanstack/react-table";

import ClaimsTable from "./claimsTable";

import { useSlowRequestToast } from "@/hooks/useSlowRequestToast";
import { ClaimParams, DEFAULT_QUERY_FILTER } from "@/api/claimsApi";
import { getClaimsByCompanyIdQueryOptions } from "@/api/queryOptions/claimsApiQueryOptions";
import { useQuery } from "@tanstack/react-query";

export const ClaimsTab = () => {
    const [{ pageSize, pageIndex }, setPagination] = useState<PaginationState>({
        pageSize: DEFAULT_QUERY_FILTER.limit,
        pageIndex: DEFAULT_QUERY_FILTER.page
    });
    const [sorting, setSorting] = useState<SortingState>([{ id: "incidentDate", desc: true }]);

    const [claimsQuery, setClaimsQuery] = useState<ClaimParams>({
        queryFilter: { ...DEFAULT_QUERY_FILTER, sortBy: "incidentDate" }
    });

    const {
        data: claimsSearchResult,
        isFetching: isFetchingClaims,
        isError: isClaimsSearchError,
        error: claimsSearchError
    } = useQuery(
        getClaimsByCompanyIdQueryOptions({
            ...claimsQuery
        })
    );

    useSlowRequestToast({
        isLoading: isFetchingClaims
    });

    useEffect(() => {
        setClaimsQuery(prev => ({
            ...prev,
            queryFilter: {
                ...prev.queryFilter,
                page: pageIndex,
                limit: pageSize,
                sortBy: sorting[0].id,
                sortDirection: sorting[0].desc ? "DESC" : "ASC"
            }
        }));
    }, [pageIndex, pageSize, sorting]);

    return (
        <Flex w="100%" mt="1.5rem">
            <ClaimsTable
                searchResult={claimsSearchResult}
                setPagination={setPagination}
                pageSize={pageSize}
                pageIndex={pageIndex}
                isFetchingClaims={isFetchingClaims}
                isClaimsSearchError={isClaimsSearchError}
                claimsQuery={claimsQuery}
                setClaimsQuery={setClaimsQuery}
                claimsSearchError={claimsSearchError}
                sorting={sorting}
                setSorting={setSorting}
            />
        </Flex>
    );
};
